'use client';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  size?: 'sm' | 'md';
  label?: string;
}

export default function Toggle({ checked, onChange, disabled = false, size = 'sm', label }: ToggleProps) {
  const trackSize = size === 'sm' ? 'w-8 h-4' : 'w-10 h-5';
  const thumbSize = size === 'sm' ? 'w-3 h-3' : 'w-4 h-4';
  const thumbTranslate = size === 'sm' ? 'translate-x-4' : 'translate-x-5';

  return (
    <label className={`inline-flex items-center gap-2 ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => !disabled && onChange(!checked)}
        className={`
          relative inline-flex items-center rounded-full transition-colors duration-200 focus:outline-none
          focus:ring-2 focus:ring-rose-500 focus:ring-offset-2 focus:ring-offset-zinc-900
          ${trackSize}
          ${checked ? 'bg-rose-600' : 'bg-zinc-700'}
          ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
        `}
      >
        <span
          className={`
            inline-block rounded-full bg-white shadow-sm transition-transform duration-200
            ${thumbSize}
            ${checked ? thumbTranslate : 'translate-x-0.5'}
          `}
        />
      </button>
      {label && <span className="text-xs text-zinc-400">{label}</span>}
    </label>
  );
}